import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ServiceItemModel } from '../../../_models/_index';
import { GeneralService,ServiceItemService } from '../../../services/_index';
import { DealStepEnum, ViewModeEnum, AlertDialogTypeEnum } from '../../../_enums/_index';
import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';
import { ServiceItemDialogComponent } from '../service-item-dialog/service-item-dialog.component';

@Component({
  selector: 'app-service-items-grid',
  templateUrl: './service-items-grid.component.html',
  styleUrls: ['./service-items-grid.component.css']
})
export class ServiceItemsGridComponent implements OnInit {

    serviceItems: ServiceItemModel[];

    constructor(private serviceItemsService: ServiceItemService,
        private dialog: MatDialog,
        private generalService: GeneralService) {
        this.serviceItems = [];
    }

    ngOnInit() {
        this.loadServiceItems();
    }

    loadServiceItems() {
        this.serviceItemsService.getServiceItems().then(result => {
            this.serviceItems = result;
        });
    }

    openAddDialog() {
        let dialogRef = this.dialog.open(ServiceItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'הוספת שירות';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Add;

        dialogRef.afterClosed().subscribe((result: ServiceItemModel) => {
            if (result) {
                result;
                let copy = Object.assign([], this.serviceItems);
                copy.push(result);
                this.serviceItems = copy;
                this.generalService.showSnackBar("הוספת שירות התבצעה בהצלחה!");
            }
        });
    }

    openEditDialog(model: ServiceItemModel) {
        let dialogRef = this.dialog.open(ServiceItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'עריכת שירות';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Edit;
        let model2edit: ServiceItemModel = new ServiceItemModel();
        model2edit = Object.assign({}, <ServiceItemModel>model);
        dialogRef.componentInstance.serviceItem = model2edit;

        dialogRef.afterClosed().subscribe((result: ServiceItemModel) => {
            if (result) {
                debugger;
                let copy = Object.assign([], this.serviceItems);
                copy.splice(this.serviceItems.findIndex(o => o.id == result.id), 1, result);
                this.serviceItems = copy;
                this.generalService.showSnackBar("עריכת שירות התבצעה בהצלחה!");
            }
        });
    }

    removeServiceItem(model: ServiceItemModel) {
        let message = "האם אתה בטוח שברצונך למחוק שירות " + model.description + "?";
        this.generalService.showConfirmDialog(message).then(result => {
            if (result) {
                this.serviceItemsService.removeServiceItem(model).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.serviceItems);
                        copy.splice(this.serviceItems.findIndex(o => o.id == model.id), 1);
                        this.serviceItems = copy;
                        this.generalService.showSnackBar("שירות הוסר בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("מחיקה בוטלה");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/service-items/service-items-grid/service-items-grid.component.ts